/* LOVITA Shopify theme — drawer, accordions, search, cart, filters */

(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var i18n = window.LOVITA_I18N || {};
  var cartI18n = i18n.cart || {};
  var toastTimer;

  function updateBagCount(count) {
    document.querySelectorAll('[data-bag-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function showAddFeedback(btn) {
    if (!btn) return;
    var was = btn.textContent;
    btn.textContent = cartI18n.toastAdded || 'Added';
    btn.disabled = true;
    setTimeout(function () {
      btn.textContent = was;
      btn.disabled = false;
    }, 1100);
  }

  function hideCartToast() {
    var toast = document.getElementById('cart-toast');
    if (!toast) return;
    toast.classList.remove('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.hidden = true;
    }, 280);
  }

  function showCartToast(productTitle) {
    var toast = document.getElementById('cart-toast');
    if (!toast) return;
    var meta = toast.querySelector('[data-toast-product]');
    if (meta) meta.textContent = productTitle || 'Your item is ready in your bag.';
    toast.hidden = false;
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideCartToast, 4200);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    var btn = e.submitter && e.submitter.closest('[data-add-feedback]');
    if (!btn) btn = form.querySelector('[data-add-feedback][type="submit"]');
    if (!btn) return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    var quantity = 1;
    if (qtyInput) {
      quantity = parseInt(qtyInput.value, 10);
      if (isNaN(quantity) || quantity < 1) quantity = 1;
    }

    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(idInput.value, 10), quantity: quantity }]
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (item) {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            return { cart: cart, item: item };
          });
      })
      .then(function (payload) {
        updateBagCount(payload.cart.item_count);
        btn.disabled = false;
        showAddFeedback(btn);
        var title = payload.item.product_title || payload.item.title || '';
        showCartToast(title);
      })
      .catch(function () {
        btn.disabled = false;
        HTMLFormElement.prototype.submit.call(form);
      });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toast-close]')) {
      hideCartToast();
      return;
    }

    var filterChip = e.target.closest('[data-line-filter]');
    if (filterChip) {
      applyLineFilter(filterChip.getAttribute('data-line-filter'), filterChip);
      return;
    }

    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      var lineKey = qtyBtn.getAttribute('data-line-key');
      var step = parseInt(qtyBtn.getAttribute('data-cart-qty'), 10);
      var cartItem = qtyBtn.closest('.cart-item');
      var qtyDisplay = cartItem && cartItem.querySelector('[data-qty-display]');
      var current = parseInt(qtyDisplay && qtyDisplay.textContent, 10) || 1;
      var next = current + step;
      if (next < 1) next = 0;
      updateCartLine(lineKey, next, cartItem);
      return;
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      updateCartLine(removeBtn.getAttribute('data-cart-remove'), 0, removeBtn.closest('.cart-item'));
      return;
    }

    var q = e.target.closest('.acc__q');
    if (q) {
      var acc = q.closest('.acc');
      var openAcc = acc.classList.toggle('is-open');
      q.setAttribute('aria-expanded', openAcc ? 'true' : 'false');
      return;
    }

    var openBtn = e.target.closest('[data-open]');
    if (openBtn) {
      var targetId = openBtn.getAttribute('data-open');
      if (targetId === 'search-modal') {
        var drawer = document.getElementById('drawer');
        if (drawer && !drawer.hidden) {
          drawer.hidden = true;
        }
      }
      var el = document.getElementById(targetId);
      if (el) {
        el.hidden = false;
        document.body.style.overflow = 'hidden';
        if (targetId === 'search-modal') {
          var searchInput = el.querySelector('[data-predictive-search-input]');
          if (searchInput) {
            window.setTimeout(function () { searchInput.focus(); }, 50);
          }
        }
      }
      return;
    }

    var closeBtn = e.target.closest('[data-close]');
    if (closeBtn) {
      var target = closeBtn.getAttribute('data-close');
      var panel = document.getElementById(target);
      if (panel) {
        panel.hidden = true;
        if (target === 'search-modal') {
          resetPredictiveSearch(panel);
        }
      }
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    hideCartToast();
    var searchModal = document.getElementById('search-modal');
    if (searchModal && !searchModal.hidden) {
      searchModal.hidden = true;
      resetPredictiveSearch(searchModal);
      document.body.style.overflow = '';
      return;
    }
    document.querySelectorAll('.drawer:not([hidden])').forEach(function (m) {
      m.hidden = true;
    });
    document.body.style.overflow = '';
  });

  function getCartDiscountRedirect() {
    var cartPage = document.querySelector('[data-cart-page]');
    var cartUrl = (cartPage && cartPage.getAttribute('data-cart-url')) || '/cart';
    return cartUrl.split('?')[0];
  }

  function buildDiscountUrl(code) {
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
  }

  function setDiscountApplyState(isLoading) {
    var applyBtn = document.querySelector('.cart-discount__apply');
    if (!applyBtn) return;
    applyBtn.disabled = !!isLoading;
    applyBtn.textContent = isLoading ? (cartI18n.applyLoading || 'Applying…') : (cartI18n.apply || 'Apply');
  }

  function reloadCartAfterDiscount(code) {
    try {
      sessionStorage.setItem('lovita_discount_attempt', code);
    } catch (err) {}
    window.location.replace(getCartDiscountRedirect());
  }

  function applyDiscountViaIframe(code) {
    return new Promise(function (resolve, reject) {
      var iframe = document.createElement('iframe');
      var finished = false;
      var discountUrl = buildDiscountUrl(code);

      function finish(err) {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        if (err) reject(err);
        else resolve();
      }

      iframe.setAttribute('hidden', 'hidden');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
      iframe.onload = function () { setTimeout(function () { finish(); }, 250); };
      iframe.onerror = function () { finish(new Error('iframe failed')); };

      var timer = setTimeout(function () { finish(); }, 5000);
      document.body.appendChild(iframe);
      iframe.src = discountUrl;
    });
  }

  function applyCartDiscount(code) {
    setDiscountApplyState(true);
    showDiscountError('');

    fetch(buildDiscountUrl(code), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'manual'
    })
      .then(function () {
        reloadCartAfterDiscount(code);
      })
      .catch(function () {
        return applyDiscountViaIframe(code).then(function () {
          reloadCartAfterDiscount(code);
        });
      })
      .catch(function () {
        setDiscountApplyState(false);
        showDiscountError(cartI18n.errors && cartI18n.errors.applyFailed ? cartI18n.errors.applyFailed : 'Could not apply that code. Try again.');
      });
  }

  function showDiscountError(message) {
    var errorEl = document.querySelector('[data-cart-discount-error]');
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  document.addEventListener('submit', function (e) {
    var discountForm = e.target.closest('[data-cart-discount]');
    if (!discountForm) return;
    e.preventDefault();
    var input = discountForm.querySelector('input[name="discount"]');
    var code = input && input.value.trim();
    if (!code) {
      showDiscountError(cartI18n.errors && cartI18n.errors.emptyCode ? cartI18n.errors.emptyCode : 'Enter a discount code.');
      if (input) input.focus();
      return;
    }
    showDiscountError('');
    applyCartDiscount(code);
  });

  if (document.querySelector('[data-cart-page]')) {
    var attemptedCode = null;
    try {
      attemptedCode = sessionStorage.getItem('lovita_discount_attempt');
      if (attemptedCode) sessionStorage.removeItem('lovita_discount_attempt');
    } catch (err) {}

    if (attemptedCode) {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var hasDiscount = (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) ||
            (cart.items && cart.items.some(function (item) {
              return item.discounts && item.discounts.length > 0;
            }));
          if (!hasDiscount) {
            showDiscountError(cartI18n.errors && cartI18n.errors.invalidCode ? cartI18n.errors.invalidCode : 'That discount code is not valid for this cart.');
            var input = document.getElementById('CartDiscount');
            if (input) input.value = attemptedCode;
          }
        })
        .catch(function () {});
    }
  }

  function formatMoney(cents) {
    cents = Math.round(Number(cents) || 0);
    var format = (window.Shopify && window.Shopify.money_format) || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(cents / 100));
    var amountComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amountNoDecimalsComma = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function padCountdown(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function parseCountdownEnd(raw) {
    if (!raw) return null;
    if (/^\d+$/.test(raw)) {
      return new Date(parseInt(raw, 10) * 1000);
    }
    var end = new Date(raw);
    return isNaN(end.getTime()) ? null : end;
  }

  function initSaleCountdown(el) {
    if (el.dataset.countdownReady) return;
    var end = parseCountdownEnd(el.getAttribute('data-ends-at'));
    if (!end) return;

    el.dataset.countdownReady = '1';

    function tick() {
      var diff = end.getTime() - Date.now();
      if (diff <= 0) {
        el.hidden = true;
        return;
      }
      var totalSec = Math.floor(diff / 1000);
      var days = Math.floor(totalSec / 86400);
      var hours = Math.floor((totalSec % 86400) / 3600);
      var minutes = Math.floor((totalSec % 3600) / 60);
      var seconds = totalSec % 60;
      var map = { days: days, hours: hours, minutes: minutes, seconds: seconds };
      Object.keys(map).forEach(function (key) {
        var node = el.querySelector('[data-pdp-count="' + key + '"]');
        if (node) node.textContent = padCountdown(map[key]);
      });
      el.hidden = false;
    }

    tick();
    setInterval(tick, 1000);
  }

  function initSaleCountdowns(root) {
    (root || document).querySelectorAll('[data-pdp-countdown]').forEach(initSaleCountdown);
  }

  function buildCardCountdownHtml(endsAt) {
    var labels = (window.LOVITA_I18N && window.LOVITA_I18N.productPage) || {};
    return '<div class="pdp-countdown pcard-countdown" data-pdp-countdown data-ends-at="' + endsAt + '">' +
      '<p class="pdp-countdown__label">' + (labels.countdownEndsIn || 'Ends in') + '</p>' +
      '<div class="pdp-countdown__grid" role="timer" aria-live="polite">' +
        '<div class="pdp-countdown__unit"><span class="pdp-countdown__num" data-pdp-count="days">00</span>' +
          '<span class="pdp-countdown__cap">' + (labels.countdownDays || 'Days') + '</span></div>' +
        '<div class="pdp-countdown__unit"><span class="pdp-countdown__num" data-pdp-count="hours">00</span>' +
          '<span class="pdp-countdown__cap">' + (labels.countdownHrs || 'Hrs') + '</span></div>' +
        '<div class="pdp-countdown__unit"><span class="pdp-countdown__num" data-pdp-count="minutes">00</span>' +
          '<span class="pdp-countdown__cap">' + (labels.countdownMin || 'Min') + '</span></div>' +
        '<div class="pdp-countdown__unit"><span class="pdp-countdown__num" data-pdp-count="seconds">00</span>' +
          '<span class="pdp-countdown__cap">' + (labels.countdownSec || 'Sec') + '</span></div>' +
      '</div></div>';
  }

  var productJsonCache = Object.create(null);

  function productJsonUrl(handle) {
    var base = root || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function savePercentLabel(compareAt, price) {
    var template = (i18n.card && i18n.card.save) || 'Save __PCT__';
    var pct = Math.round((compareAt - price) * 100 / compareAt);
    return template.replace('__PCT__', pct + '%');
  }

  function applySaleToCard(card, sale) {
    if (!sale || !sale.compare_at || sale.compare_at <= sale.price) return false;

    var priceEl = card.querySelector('[data-card-price]');
    if (priceEl) {
      priceEl.innerHTML =
        '<span class="pcard__amount">' + formatMoney(sale.price) + '</span>' +
        '<s class="pcard__compare">' + formatMoney(sale.compare_at) + '</s>' +
        '<span class="pcard__save">' + savePercentLabel(sale.compare_at, sale.price) + '</span>';
    }
    card.setAttribute('data-price', sale.price);
    card.setAttribute('data-on-sale', '1');
    card.classList.add('pcard--sale');

    var saleEnds = sale.ends ? String(sale.ends) : card.getAttribute('data-sale-ends');
    if (saleEnds && !card.querySelector('[data-pdp-countdown]')) {
      // The countdown sits between the price and the button.
      var body = card.querySelector('.pcard__body');
      if (priceEl) {
        priceEl.insertAdjacentHTML('afterend', buildCardCountdownHtml(saleEnds));
        initSaleCountdowns(card);
      } else if (body) {
        body.insertAdjacentHTML('beforeend', buildCardCountdownHtml(saleEnds));
        initSaleCountdowns(card);
      }
    }

    card.dataset.saleEnhanced = '1';
    return true;
  }

  function fetchProductJson(handle) {
    if (productJsonCache[handle]) {
      return Promise.resolve(productJsonCache[handle]);
    }
    return fetch(productJsonUrl(handle), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('product json');
        return res.json();
      })
      .then(function (data) {
        productJsonCache[handle] = data;
        return data;
      });
  }

  function pickProductVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0];
  }

  function enhanceProductCard(card) {
    if (card.dataset.saleEnhanced) return;

    if (card.getAttribute('data-on-sale') === '1') {
      initSaleCountdowns(card);
      card.dataset.saleEnhanced = '1';
      return;
    }

    var handle = card.getAttribute('data-product-handle');
    if (!handle) return;

    var sale = window.LOVITA_PRODUCT_SALES && window.LOVITA_PRODUCT_SALES[handle];
    if (sale && applySaleToCard(card, sale)) return;

    fetchProductJson(handle)
      .then(function (product) {
        var variant = pickProductVariant(product);
        if (!variant) {
          card.dataset.saleEnhanced = '1';
          return;
        }

        var payload = {
          compare_at: variant.compare_at_price,
          price: variant.price,
          ends: card.getAttribute('data-sale-ends') || null
        };
        if (!payload.ends && window.LOVITA_PRODUCT_SALES && window.LOVITA_PRODUCT_SALES[handle]) {
          payload.ends = window.LOVITA_PRODUCT_SALES[handle].ends;
        }

        if (!applySaleToCard(card, payload)) {
          card.dataset.saleEnhanced = '1';
        }
      })
      .catch(function () {
        card.dataset.saleEnhanced = '1';
      });
  }

  function enhanceProductCards(scope) {
    (scope || document).querySelectorAll('.pcard[data-product-handle]').forEach(enhanceProductCard);
  }

  function syncCartPage(cart) {
    updateBagCount(cart.item_count);

    if (!cart.item_count) {
      window.location.reload();
      return;
    }

    cart.items.forEach(function (item) {
      var row = document.querySelector('.cart-item[data-line-key="' + item.key + '"]');
      if (!row) return;
      var qtyDisplay = row.querySelector('[data-qty-display]');
      var qtyInput = row.querySelector('[data-qty-input]');
      var priceEl = row.querySelector('[data-line-price]');
      if (qtyDisplay) qtyDisplay.textContent = item.quantity;
      if (qtyInput) qtyInput.value = item.quantity;
      if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
    });

    document.querySelectorAll('.cart-item[data-line-key]').forEach(function (row) {
      var key = row.getAttribute('data-line-key');
      var exists = cart.items.some(function (item) {
        return item.key === key;
      });
      if (!exists) row.remove();
    });

    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = formatMoney(cart.items_subtotal_price);
    });
    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });

    var meta = document.querySelector('.cart-head .meta');
    if (meta) {
      meta.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    }
  }

  function updateCartLine(lineKey, quantity, cartItemEl) {
    if (!lineKey) return;
    if (quantity < 0) quantity = 0;
    if (cartItemEl) cartItemEl.classList.add('is-updating');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (cart) {
        syncCartPage(cart);
      })
      .catch(function () {
        window.location.href = root + 'cart';
      })
      .finally(function () {
        if (cartItemEl) cartItemEl.classList.remove('is-updating');
      });
  }

  function applyLineFilter(line, activeChip) {
    var bar = document.querySelector('[data-lineup-filter]');
    var sections = document.querySelectorAll('[data-lineup-section]');
    var empty = document.querySelector('[data-lineup-empty]');
    if (!bar) return;

    bar.querySelectorAll('[data-line-filter]').forEach(function (chip) {
      var on = chip === activeChip;
      chip.classList.toggle('chip--solid', on);
      chip.classList.toggle('chip--out', !on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var visible = 0;
    sections.forEach(function (section) {
      var show = line === 'all' || section.getAttribute('data-lineup-section') === line;
      section.hidden = !show;
      if (show) visible += 1;
    });
    if (empty) empty.hidden = visible > 0;
  }

  function resetPredictiveSearch(modal) {
    if (!modal) return;
    var input = modal.querySelector('[data-predictive-search-input]');
    var resultsEl = modal.querySelector('[data-predictive-search-results]');
    var emptyEl = modal.querySelector('[data-predictive-search-empty]');
    var viewAllEl = modal.querySelector('[data-predictive-search-view-all]');
    var statusEl = modal.querySelector('[data-predictive-search-status]');
    if (input) input.value = '';
    if (resultsEl) {
      resultsEl.innerHTML = '';
      resultsEl.hidden = true;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (viewAllEl) viewAllEl.hidden = true;
    if (statusEl) statusEl.textContent = '';
  }

  function initPredictiveSearch() {
    var modal = document.getElementById('search-modal');
    if (!modal) return;

    var input = modal.querySelector('[data-predictive-search-input]');
    var resultsEl = modal.querySelector('[data-predictive-search-results]');
    var emptyEl = modal.querySelector('[data-predictive-search-empty]');
    var viewAllEl = modal.querySelector('[data-predictive-search-view-all]');
    var statusEl = modal.querySelector('[data-predictive-search-status]');
    if (!input || !resultsEl) return;

    var debounceTimer;
    var abortController;

    function clearResults() {
      resultsEl.innerHTML = '';
      resultsEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      if (viewAllEl) viewAllEl.hidden = true;
      if (statusEl) statusEl.textContent = '';
    }

    function renderResults(products, query) {
      if (!products.length) {
        clearResults();
        if (emptyEl) emptyEl.hidden = false;
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      resultsEl.hidden = false;
      if (viewAllEl) {
        viewAllEl.href = root + 'search?type=product&q=' + encodeURIComponent(query);
        viewAllEl.hidden = false;
      }
      if (statusEl) {
        statusEl.textContent = products.length + (products.length === 1 ? ' product' : ' products');
      }

      resultsEl.innerHTML = products.map(function (product) {
        var image = product.featured_image && product.featured_image.url
          ? '<img class="search-modal__thumb" src="' + product.featured_image.url + '" alt="" width="48" height="48" loading="lazy">'
          : '<span class="search-modal__thumb search-modal__thumb--empty" aria-hidden="true"></span>';
        var price = product.price ? '<span class="search-modal__result-price">' + product.price + '</span>' : '';
        return '<li><a class="search-modal__result" href="' + product.url + '">' + image +
          '<span class="search-modal__result-copy"><span class="search-modal__result-title">' + product.title + '</span>' +
          price + '</span></a></li>';
      }).join('');
    }

    function fetchSuggestions(query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      var url = root + 'search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

      fetch(url, {
        signal: abortController.signal,
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products, query);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          clearResults();
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < 2) {
        clearResults();
        return;
      }
      debounceTimer = window.setTimeout(function () {
        fetchSuggestions(query);
      }, 280);
    });
  }

  function initSearchPageForm() {
    var form = document.querySelector('[data-search-page-form]');
    var input = form && form.querySelector('[data-search-page-input]');
    if (!form || !input) return;

    var debounceTimer;
    var DEBOUNCE_MS = 900;
    var lastSubmitted = (input.value || '').trim();

    function submitSearch() {
      var query = input.value.trim();
      if (query === lastSubmitted) return;
      if (query.length >= 2 || query.length === 0) {
        lastSubmitted = query;
        form.submit();
      }
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(submitSearch, DEBOUNCE_MS);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      clearTimeout(debounceTimer);
      e.preventDefault();
      lastSubmitted = input.value.trim();
      form.submit();
    });
  }

  var q = document.getElementById('q');
  if (q && window.LOVITA_CATALOG) {
    var results = document.getElementById('results');
    var count = document.getElementById('count');
    var empty = document.getElementById('empty');

    function priceLabel(p) {
      if (p.price_formatted) return p.price_formatted;
      if (p.price_cents != null) return formatMoney(p.price_cents);
      if (p.price != null) return p.price;
      return '';
    }

    function card(p) {
      var form = p.variant_id
        ? '<form method="post" action="' + root + 'cart/add">' +
            '<input type="hidden" name="id" value="' + p.variant_id + '">' +
            '<button type="submit" class="btn btn--card" data-add-feedback>Add to cart</button>' +
          '</form>'
        : '<a class="btn btn--card" href="' + root + 'products/' + p.handle + '">View product</a>';

      var stars = '';
      if (p.reviews && Number(p.reviews) > 0 && p.rating) {
        var fill = Math.max(0, Math.min(100, Number(p.rating) * 20));
        stars = '<div class="rating-stars pcard__rating" role="img" aria-label="' +
            p.rating + ' / 5 (' + p.reviews + ')">' +
          '<span class="rating-stars__track" aria-hidden="true">\u2605\u2605\u2605\u2605\u2605' +
            '<span class="rating-stars__fill" style="width:' + fill + '%">' +
              '\u2605\u2605\u2605\u2605\u2605</span></span></div>';
      }

      return '<div class="pcard" data-product-handle="' + p.handle + '" data-sale-ends="' + (p.sale_ends_at || '') + '">' +
        '<a href="' + root + 'products/' + p.handle + '" class="ph ph--' + p.line + ' pcard__img">' +
          (p.badge ? '<span class="chip chip--status">' + p.badge + '</span>' : '') +
          '<span class="chip chip--' + p.line + '">' +
            ((window.LOVITA_I18N && window.LOVITA_I18N.lineup && window.LOVITA_I18N.lineup[p.line]) ||
              (p.line.charAt(0).toUpperCase() + p.line.slice(1))) + '</span>' +
          '<span class="ph__vessel"></span></a>' +
        stars +
        '<a href="' + root + 'products/' + p.handle + '" class="pcard__link">' +
          '<p class="pcard__name">' + p.name + '</p></a>' +
        '<p class="pcard__price" data-card-price><span class="pcard__amount">' + priceLabel(p) + '</span></p>' +
        form + '</div>';
    }

    function render(term) {
      var t = (term || '').trim().toLowerCase();
      var hits = window.LOVITA_CATALOG.filter(function (p) {
        if (!t) return true;
        return (p.name + ' ' + p.benefit + ' ' + p.line).toLowerCase().indexOf(t) > -1;
      });
      if (results) {
        results.innerHTML = hits.map(card).join('');
        enhanceProductCards(results);
      }
      if (count) count.textContent = hits.length + (hits.length === 1 ? ' product' : ' products');
      if (empty) empty.hidden = hits.length > 0;
    }

    q.addEventListener('input', function () { render(q.value); });
    document.querySelectorAll('[data-q]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        q.value = chip.getAttribute('data-q');
        render(q.value);
        q.focus();
      });
    });
    render('');
  }

  function switchStoreLocale(btn) {
    var form = btn.closest('form');
    if (!form) return;
    var input = form.querySelector('input[name="locale_code"]');
    if (!input) return;
    var localeCode = btn.getAttribute('data-value') || '';
    if (!localeCode) return;
    input.value = localeCode;
    btn.disabled = true;

    var fallbackUrl = btn.getAttribute('data-url');
    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      redirect: 'follow'
    })
      .then(function (res) {
        if (res.url && res.url.indexOf('/localization') === -1) {
          window.location.assign(res.url);
          return;
        }
        if (fallbackUrl) {
          window.location.assign(fallbackUrl);
          return;
        }
        form.submit();
      })
      .catch(function () {
        if (fallbackUrl) {
          window.location.assign(fallbackUrl);
          return;
        }
        form.submit();
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lang-switch]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    switchStoreLocale(btn);
  });

  function initLandingHeroSlideshow() {
    document.querySelectorAll('[data-hero-slideshow]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
      if (slides.length < 2) return;

      var intervalMs = parseInt(root.getAttribute('data-hero-interval'), 10);
      if (isNaN(intervalMs) || intervalMs < 1000) intervalMs = 5000;

      var index = 0;
      var timer = null;
      var hoveringSlide = false;
      var slidesWrap = root.querySelector('.landing-hero__slides') || root;

      function show(target) {
        index = (target + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var isActive = i === index;
          slide.classList.toggle('is-active', isActive);
          // Only the visible slide's link should be reachable by keyboard.
          var link = slide.querySelector('a');
          if (link) link.setAttribute('tabindex', isActive ? '0' : '-1');
        });
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (hoveringSlide) return;
        timer = setInterval(function () {
          show(index + 1);
        }, intervalMs);
      }

      show(0);
      start();

      var prev = root.querySelector('[data-hero-prev]');
      var next = root.querySelector('[data-hero-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          show(index - 1);
          start();
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          show(index + 1);
          start();
        });
      }

      slidesWrap.addEventListener('mouseenter', function () {
        hoveringSlide = true;
        stop();
      });
      slidesWrap.addEventListener('mouseleave', function () {
        hoveringSlide = false;
        start();
      });
    });
  }

  /* Shopify's hosted logout always returns to the primary-locale homepage, and
     there is no return_to on logout. Remember the locale the customer signed
     out from, then restore it once we're back on the storefront. */
  var LOGOUT_RETURN_KEY = 'lovita:logout-return';

  function readLogoutReturn() {
    try {
      var value = sessionStorage.getItem(LOGOUT_RETURN_KEY);
      sessionStorage.removeItem(LOGOUT_RETURN_KEY);
      return value;
    } catch (e) {
      return null;
    }
  }

  function initLogoutLocaleReturn() {
    document.querySelectorAll('[data-logout-return]').forEach(function (link) {
      link.addEventListener('click', function () {
        try {
          sessionStorage.setItem(LOGOUT_RETURN_KEY, link.getAttribute('data-logout-return') || '/');
        } catch (e) {
          /* private mode — fall back to Shopify's default destination */
        }
      });
    });

    var pending = readLogoutReturn();
    if (!pending) return;

    var prefix = pending.replace(/\/+$/, '');
    if (!prefix) return;

    var path = window.location.pathname;
    if (path === prefix || path.indexOf(prefix + '/') === 0) return;

    window.location.replace(prefix + '/');
  }

  function bootSaleCards() {
    initSaleCountdowns(document);
    enhanceProductCards(document);
    initPredictiveSearch();
    initSearchPageForm();
    initLandingHeroSlideshow();
    initLogoutLocaleReturn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSaleCards);
  } else {
    bootSaleCards();
  }
})();
